// Sound effects for mood selection
export const playMoodSound = (moodValue) => {
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  
  const soundConfigs = {
    magical: { type: 'sine', frequencies: [523, 659, 784, 1047], duration: 0.15, delay: 0.08 },
    amazing: { type: 'sine', frequencies: [440, 554, 659, 880], duration: 0.12, delay: 0.06 },
    loved: { type: 'sine', frequencies: [392, 494, 587], duration: 0.2, delay: 0.1 },
    on_fire: { type: 'sawtooth', frequencies: [220, 277, 330, 440], duration: 0.08, delay: 0.04 },
    hopeful: { type: 'sine', frequencies: [349, 440, 523, 659], duration: 0.18, delay: 0.1 },
    dreamy: { type: 'sine', frequencies: [262, 330, 392], duration: 0.3, delay: 0.15 },
    free: { type: 'sine', frequencies: [523, 659, 784, 880, 1047], duration: 0.1, delay: 0.05 },
    peaceful: { type: 'sine', frequencies: [262, 330, 392], duration: 0.4, delay: 0.2 },
    energized: { type: 'square', frequencies: [330, 440, 554, 659], duration: 0.06, delay: 0.03 },
    calm: { type: 'sine', frequencies: [196, 262, 330], duration: 0.5, delay: 0.25 },
    thoughtful: { type: 'sine', frequencies: [294, 349, 440], duration: 0.25, delay: 0.12 },
    focused: { type: 'triangle', frequencies: [440, 554, 659], duration: 0.1, delay: 0.05 },
    tired: { type: 'sine', frequencies: [196, 175, 165], duration: 0.4, delay: 0.2 },
    melancholy: { type: 'sine', frequencies: [220, 196, 175], duration: 0.35, delay: 0.18 },
    strong: { type: 'square', frequencies: [110, 147, 185, 220, 294], duration: 0.15, delay: 0.05 },
  };

  const config = soundConfigs[moodValue] || soundConfigs.magical;
  
  config.frequencies.forEach((freq, index) => {
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    
    oscillator.type = config.type;
    oscillator.frequency.setValueAtTime(freq, audioContext.currentTime);
    
    gainNode.gain.setValueAtTime(0, audioContext.currentTime + index * config.delay);
    gainNode.gain.linearRampToValueAtTime(0.15, audioContext.currentTime + index * config.delay + 0.02);
    gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + index * config.delay + config.duration);
    
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    
    oscillator.start(audioContext.currentTime + index * config.delay);
    oscillator.stop(audioContext.currentTime + index * config.delay + config.duration + 0.1);
  });
};

// Sparkle effect when clicking New Entry or badges
export const createSparkleEffect = (event) => {
  const sparkles = ['✨', '⭐', '💫', '🌟', '✦', '★'];
  const colors = ['color-pink', 'color-orange', 'color-purple', 'color-gold', 'color-cyan', 'color-white'];
  
  const container = document.createElement('div');
  container.className = 'sparkle-container';
  container.style.left = `${event.clientX}px`;
  container.style.top = `${event.clientY}px`;
  document.body.appendChild(container);

  // Create expanding rings
  for (let i = 1; i <= 3; i++) {
    const ring = document.createElement('div');
    ring.className = `sparkle-ring ring-${i}`;
    container.appendChild(ring);
  }

  // Create many sparkle particles - outer burst
  for (let i = 0; i < 20; i++) {
    const particle = document.createElement('span');
    particle.className = `sparkle-particle ${colors[Math.floor(Math.random() * colors.length)]}`;
    particle.textContent = sparkles[Math.floor(Math.random() * sparkles.length)];
    
    const angle = (i / 20) * 360 + (Math.random() * 20 - 10);
    const distance = 80 + Math.random() * 100;
    const tx = Math.cos(angle * Math.PI / 180) * distance;
    const ty = Math.sin(angle * Math.PI / 180) * distance;
    
    particle.style.setProperty('--tx', `${tx}px`);
    particle.style.setProperty('--ty', `${ty}px`);
    particle.style.animationDelay = `${Math.random() * 0.15}s`;
    particle.style.fontSize = `${1.5 + Math.random() * 1}rem`;
    
    container.appendChild(particle);
  }

  // Inner sparkles
  for (let i = 0; i < 10; i++) {
    const particle = document.createElement('span');
    particle.className = `sparkle-particle ${colors[Math.floor(Math.random() * colors.length)]}`;
    particle.textContent = sparkles[Math.floor(Math.random() * sparkles.length)];
    
    const angle = (i / 10) * 360;
    const distance = 30 + Math.random() * 40;
    const tx = Math.cos(angle * Math.PI / 180) * distance;
    const ty = Math.sin(angle * Math.PI / 180) * distance;
    
    particle.style.setProperty('--tx', `${tx}px`);
    particle.style.setProperty('--ty', `${ty}px`);
    particle.style.animationDelay = `${0.05 + Math.random() * 0.1}s`;
    particle.style.fontSize = `${1 + Math.random() * 0.8}rem`;
    
    container.appendChild(particle);
  }

  // Play a magical sound
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const frequencies = [523, 659, 784, 1047, 1319];
    frequencies.forEach((freq, index) => {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(freq, audioContext.currentTime);
      gainNode.gain.setValueAtTime(0, audioContext.currentTime + index * 0.04);
      gainNode.gain.linearRampToValueAtTime(0.1, audioContext.currentTime + index * 0.04 + 0.02);
      gainNode.gain.linearRampToValueAtTime(0, audioContext.currentTime + index * 0.04 + 0.25);
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      oscillator.start(audioContext.currentTime + index * 0.04);
      oscillator.stop(audioContext.currentTime + index * 0.04 + 0.35);
    });
  } catch (e) {
    console.log('Audio not available');
  }

  // Remove container after animation
  setTimeout(() => container.remove(), 1100);
};
